<div class="export-dialog">

  <!-- Header -->
  <div class="d-flex align-items-start gap-2 p-3 pb-2">
    <div class="flex-fill">
      <div class="mat-font-label-sm text-uppercase fw-semibold">
        {{ data.eyebrow }}
      </div>
      <h2 class="mat-font-title-lg fw-semibold mb-1 mt-1">{{ data.title }}</h2>
      <p class="mat-font-body-sm mb-0">{{ data.subtitle }}</p>
    </div>
    <button matIconButton (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="export-dialog__body px-3 py-2">

    <!-- Optional: Text Search section -->
    @if (data.textSearchQuery != null) {
      <section class="export-section">
        <div class="export-section__head">
          <mat-icon class="export-section__icon">search</mat-icon>
          <span class="export-section__title">Text Search</span>
        </div>
        <div class="export-query">
          <div class="mat-font-body-sm mb-1">
            Query: <q>{{ data.textSearchQuery }}</q>
          </div>
          <code class="export-query__value">{{ data.textSearchQuery }}</code>
        </div>
      </section>
    }

    <!-- Optional: Layers section -->
    @if (data.layers && data.layers.length > 0) {
      <section class="export-section">
        <div class="export-section__head">
          <mat-icon class="export-section__icon">layers</mat-icon>
          <span class="export-section__title">Layers to export</span>
          <button matButton type="button" class="ms-auto"
                  (click)="setAllLayers(!allChecked())">
            {{ allChecked() ? "Clear all" : "Select all" }}
          </button>
        </div>
        <div class="export-layers">
          @for (layer of data.layers; track layer.id) {
            <label class="export-layer"
                   [class.is-on]="checked()[layer.id]"
                   [style.--obj-color]="layer.color">
              <mat-checkbox [checked]="!!checked()[layer.id]"
                            (change)="toggleLayer(layer.id)">
              </mat-checkbox>
              <span class="export-layer__dot" [style.background]="layer.color"></span>
              <span class="export-layer__name text-truncate">{{ layer.name }}</span>
              <span class="export-layer__count">{{ layer.count | number }}</span>
            </label>
          }
        </div>
        <div class="mat-font-body-sm mt-2">
          @if (selectedLayerCount() === 0) {
            Select at least one layer to export.
          } @else {
            {{ totalSelectedDetections() | number }} detections across
            {{ selectedLayerCount() }} layer{{ selectedLayerCount() > 1 ? "s" : "" }} selected.
          }
        </div>
      </section>
    }

    <!-- Optional: Max records -->
    @if (showMaxRecords) {
      <section class="export-section">
        <div class="export-section__head">
          <mat-icon class="export-section__icon">settings</mat-icon>
          <span class="export-section__title">Export Configuration</span>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>Maximum records</mat-label>
          <input matInput
                 type="number"
                 [value]="records()"
                 min="1"
                 [max]="maxRecordsCap"
                 step="1"
                 (input)="setRecords($any($event.target).value)" />
          <span matSuffix>records</span>
        </mat-form-field>
        <div class="mat-font-body-sm">
          Maximum {{ maxRecordsCap | number }} records allowed.
        </div>
      </section>
    }

    <!-- Export format cards -->
    <section class="export-section">
      <div class="export-section__head">
        <mat-icon class="export-section__icon">download</mat-icon>
        <span class="export-section__title">Export Format</span>
      </div>
      <div class="export-format-grid">
        @for (fmt of data.formats; track fmt.id) {
          <button type="button"
                  class="export-format-card"
                  [class.is-selected]="isSelected(fmt)"
                  [style.--card-accent]="fmt.accent"
                  (click)="selectFormat(fmt.id)">
            <div class="d-flex align-items-start gap-2">
              <mat-icon class="export-format-card__icon">{{ fmt.icon }}</mat-icon>
              <div class="flex-fill">
                <div class="mat-font-title-sm fw-semibold">{{ fmt.label }}</div>
                <div class="export-format-card__ext">{{ fmt.ext }}</div>
              </div>
              @if (fmt.recommended) {
                <span class="export-format-card__rec">Recommended</span>
              }
            </div>
            <div class="mat-font-body-sm mt-2">
              {{ fmt.desc }}
            </div>
          </button>
        }
      </div>
    </section>

  </div>

  <!-- Footer -->
  <div class="d-flex justify-content-end gap-2 px-3 py-2">
    <button matButton type="button" (click)="cancel()">Cancel</button>
    <button matButton="filled" color="primary" type="button"
            [disabled]="!canExport()"
            (click)="apply()">
      <mat-icon>download</mat-icon> {{ data.applyLabel }}
    </button>
  </div>

</div>
